import VueRouter from "vue-router";
import Vue  from "vue";
import VueRouterPrefetch from 'vue-router-prefetch'

import routes from './routes'
import initProgress from "src/routes/progressbar";
import store from "src/store";

Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)

const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
      if (to.hash) {
          return { selector: to.hash }
      } else {
          return { x: 0, y: 0 }
      }
  }
})


// Nav Guard
router.beforeEach((to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
      // Check if NO logged user
    if(!store.getters['auth/isLoggedIn']) {
          // Go to login
          next({
              path: '/login',
              query: {
                  redirect: to.fullPath
              }
          });
      } else {
          // Proceed to route
          next();
      }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // TODO:: Add authenticated check
      // Check if NO logged user
    //   if (firebase.auth().currentUser) {
    //       // Go to login
    //       next({
    //           path: '/',
    //           query: {
    //               redirect: to.fullPath
    //           }
    //       });
    //   } else {
    //       // Proceed to route
    //       next();
    //   }
  } else {
      // Proceed to route
      next();
  }
});

initProgress(router);

export default router